module.exports = __webpack_public_path__ + "img/urban.48bd7e9.jpg";